import { List, ListItemButton, ListItem, styled } from "@mui/material";
import { useEffect, useState } from "react";

interface IProps {
  topicValues: string[];
  currentTopic?: any;
  setCurrentTopic: (topic: string) => void;
  isFullScreen?: boolean;
  setSearchPage?: React.Dispatch<React.SetStateAction<number>>;
  color?: string;
}

const TopMenu = ({ topicValues, isFullScreen, currentTopic, setCurrentTopic, setSearchPage, color = "white" }: IProps) => {
  if (!currentTopic) { setCurrentTopic(topicValues[0]); }

  const [isShow, setIsShow] = useState<boolean>(false);

  const handleCategoryClick = (topicId: string) => () => {
    setCurrentTopic(topicId);
    if (setSearchPage) { setSearchPage(1); }
  };

  useEffect(() => {
    const TIME = 100;

    const timer = setTimeout(() => {
      setIsShow(true);
    }, TIME);
    return () => clearTimeout(timer);
  }, []);

  return (
    <List
      className="topMenu"
      component="nav"
      sx={{
        position: isFullScreen ? "sticky" : "relative",
        display: "flex",
        height: "60px",
        alignItems: "center",
        padding: 0,
        width: "100%",
        overscrollBehavior: "contain",
        msOverflowStyle: "none",
        scrollbarWidth: "0 !important",
        overflowX: "hidden",
        "::-webkit-scrollbar": {
          display: "none",
        }
      }}

    >
      {isShow && topicValues.map((topic, index) => {
        return (
          <StyledListItem onClick={handleCategoryClick(topic)} key={topic} color={color} sx={{
            div: { width: "max-content" },
          }} isCurrentTopic={topic === currentTopic} >
            <ListItemButton sx={{ padding: 0 }}>{topic}</ListItemButton>
          </StyledListItem>
        );
      })}
    </List>
  );
};

const StyledListItem = styled(ListItem,
  { shouldForwardProp: (prop) => prop !== "isCurrentTopic" }
)<{ isCurrentTopic: boolean; color: string }>(({ isCurrentTopic, color }) => {
  return {
    flexDirection: "column",
    display: "relative",
    color: color,
    opacity: isCurrentTopic ? "1" : "0.5",
    transition: "opacity .3s ease",

    "&:hover": {
      opacity: isCurrentTopic ? "1" : "0.8"
    },

    "&::after": isCurrentTopic ? {
      // eslint-disable-next-line
      content: '""',
      width: "18px",
      height: "2px",
      top: "8px",
      borderRadius: "25px",
      background: "linear-gradient(180deg, #8F2CF2 0%, #CD4CFF 100%)",
    } : {}
  };
});

export default TopMenu;
